import React from "react";

import FormBuilderInput from "./FormBuilderInput";

export default function FormBuilderSection({ section, values, className, onChange }) {
	return (
		<div className={["form-section", className].filter(Boolean).join(" ")} data-section-id={section.id}>
			<h3>{section.heading}</h3>
			<p className="instr">{section.instructions}</p>
			{
				section.inputs && section.inputs.map((input, key) =>
					<FormBuilderInput
						value={values[input.id]}
						{...input}
						onChange={value => onChange(input.id, value)}
						key={key}
					/>
				)
			}
		</div>
	);
}
